/**
 * The placeholder level thumbnail (A-13, reference 02): a capsule on a
 * platform over a horizon, drawn with theme variables only. Each tile's sky is
 * tinted by a hue step from the accent (CSS relative color syntax), so tiles
 * are distinguishable without inventing per-level art.
 */
import type { CSSProperties } from "react";

export function LevelThumbnail({ hueStep }: { hueStep: number }) {
  return (
    <svg
      className="kn-thumb"
      viewBox="0 0 120 68"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      style={{ "--kn-hue-step": hueStep } as CSSProperties}
    >
      <rect className="kn-thumb__sky" width="120" height="68" />
      <rect className="kn-thumb__floor" y="34" width="120" height="34" />
      <path
        className="kn-thumb__grid"
        d="M60 34L0 68M60 34L30 68M60 34L60 68M60 34L90 68M60 34L120 68M0 44h120M0 55h120"
      />
      <ellipse className="kn-thumb__platform" cx="60" cy="50" rx="18" ry="4" />
      <rect className="kn-thumb__figure" x="55" y="30" width="10" height="20" rx="5" />
    </svg>
  );
}
